var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"role-line-menu"},[_c(_setup.MenuIcon,{attrs:{"dropdownItems":_setup.visibleMenuItems,"isOpen":_setup.isMenuOpen,"width":280},on:{"onClick":_setup.handleMenuClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }